var React = require('react');

function PaperClip (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M15.81 8.362l-7.002 7.002A4.574 4.574 0 1 1 2.34 8.895l7.002-7.002a3.05 3.05 0 0 1 4.312 4.313l-7.01 7.001a1.525 1.525 0 1 1-2.156-2.156l6.469-6.46"}));
}

PaperClip.defaultProps = {"width":"17","height":"18","viewBox":"0 0 17 18"};

module.exports = PaperClip;

PaperClip.default = PaperClip;
